import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ErrorService } from '@services';
import { catchError, map } from 'rxjs/operators';
import { NotificationModel, NotificationRaw } from '../models';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@app/_core/config.service';
import { convertNotificationRawToModel } from '@component/notifications/helpers/notification-helper';
import { WebSocketServerService } from '@app/_core/websocket-server.service';

@Injectable({ providedIn: 'root' })
export class NotificationsAPIService {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly webSocketServer: WebSocketServerService,
    private readonly errorService: ErrorService
  ) {}

  public fetchNotifications(): Observable<NotificationModel[]> {
    const url = `${this.configService.config.rootApiDomain}/api/notifications/`;

    return this.http.get<NotificationRaw[]>(url).pipe(
      map(list => list.map(convertNotificationRawToModel)),
      catchError(err => this.errorService.handle(err))
    );
  }

  public markNotificationsAsRead$(notificationIds: number[] = []): Observable<void> {
    const url = `${this.configService.config.rootApiDomain}/api/notifications/isread`;

    return this.http.patch<void>(url, { notificationIds }).pipe(catchError((err: Error) => this.errorService.handle(err)));
  }

  public onNotificationCreated$(): Observable<NotificationModel> {
    return this.webSocketServer.onMessage('NOTIFICATION_NEW').pipe(
      map(payload => convertNotificationRawToModel(payload as NotificationRaw)),
      catchError(err => this.errorService.handle(err))
    );
  }
}
